<template>
    <v-container class="ma-0 pa-0 mw-100">
      <v-row>
        <v-col cols="12">
          <header-big :title="$t('Authenticate.existingSignature')"></header-big>
        </v-col>
      </v-row>
  
      <v-row align="center">
      <v-col cols="12" sm="12" v-if="!mobile">
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step key="1-step" :complete="step > 1" step="1">{{
              $t("HomePage.header.request_form")
            }}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step key="2-step" :complete="step > 2" step="2">{{
              $t("HomePage.header.request_download")
            }}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step key="3-step" :complete="step > 3" step="3">{{
              $t("HomePage.header.request_upload")
            }}</v-stepper-step>
            <v-divider></v-divider>
          </v-stepper-header>
        </v-stepper>
      </v-col>
    </v-row>
  
    <v-row justify="center">
        <v-col cols="12" sm="12">
            <router-view @step="updateStepper" />
        </v-col>
    </v-row>
    </v-container>
  </template>
  
  <script>
  import i18n from "@/i18n";
  import HeaderBig from "../../components/ui/text/HeaderBig";
  
  export default {
    name: "AuthenticateExistingSignature",
    title: i18n.t("Headers.sign"),
    components: {
      HeaderBig,
    },
    data() {
      return {
        step: 1,
        mobile: false,
        revokeDialog: false,
        aes: true,
      };
    },
    computed: {
      currentWorkflow() {
        return this.$store.state.auth.workflow;
      },
    },
    created() {
      this.mobile = this.$vuetify.breakpoint.mdAndDown;
    },
    methods: {
      updateStepper(val) {
        this.step = val;
      },
    },
  };
  </script>